<template>
    <VeeForm :validation-schema="sizeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12 mb-2 mb-md-0">
        <form ref="form" @submit="handleSubmit($event, onSizeSubmit)" method="post" :action="this.baseUrl + '/enter-size-submit'" class="size-form">
            <input v-if="tyrePosition != null" type="hidden" name="tyre_position" :value="tyrePosition" />
            <div class="row gx-3 w-100 gy-2">
                <div class="col-6 col-sm-4" v-for="(option, key) in formattedOptions" :key="key">
                    <template v-if="typeof(selectedSizeOption) != 'undefined' && Object.keys(selectedSizeOption).length > 0">
                        <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                            <Field :id="option.name" v-slot="{ value }" :name="option.name" :aria-label="option.name" as="select" class="form-select size-input text-navy" v-model="selectedSizeOption[option.name]" :title="errors[option.name]" :class="{'error': errors[option.name]}" @change="onSizeFieldChange(option.name, $event, selectedSizeOption)">
                                <option value="">{{ option.name == 'speed' ? (option.label + ' - All') : option.label }}</option>
                                <template v-if="option.groups">
                                    <optgroup v-if="option.groups.popular.length" label="Most Popular">
                                        <option v-for="item in option.groups.popular" :key="'popular-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                    </optgroup>
                                    <optgroup v-if="option.groups.rest.length" :label="option.groups.allLabel">
                                        <option v-for="item in option.groups.rest" :key="'all-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                    </optgroup>
                                </template>
                                <template v-else>
                                    <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(selectedSizeOption[option.name])">{{ item }}</option>
                                </template>
                            </Field>
                        </Popper>
                    </template>
                    <template v-else>
                        <Popper :content="errors[option.name]" arrow placement="top" class="w-100 m-0 border-0" :show="errors[option.name] ? true : false">
                            <Field :id="option.name" v-slot="{ value }" :name="option.name" :aria-label="option.name" as="select" class="form-select size-input text-navy" :title="errors[option.name]" :class="{'error': errors[option.name]}" @change="onSizeFieldChange(option.name, $event)">
                                <option value="">{{ option.name == 'speed' ? (option.label + ' - All') : option.label }}</option>
                                <template v-if="option.groups">
                                    <optgroup v-if="option.groups.popular.length" label="Most Popular">
                                        <option v-for="item in option.groups.popular" :key="'popular-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                    </optgroup>
                                    <optgroup v-if="option.groups.rest.length" :label="option.groups.allLabel">
                                        <option v-for="item in option.groups.rest" :key="'all-' + item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                    </optgroup>
                                </template>
                                <template v-else>
                                    <option v-for="item in option.data" :key="item" :value="item" :selected="value && value.includes(item)">{{ item }}</option>
                                </template>
                            </Field>
                        </Popper>
                    </template>
                </div>
                <div class="col-6 col-sm-4" :class="tyrePosition != null ? 'd-none' : ''">
                    <Popper :content="errors.size_postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.size_postcode ? true : false">
                        <Field id="size_postcode" name="size_postcode" type="text" class="form-control size-postcode" :value="postcode" placeholder="Postcode" autocomplete="off" :class="{'error': errors.size_postcode}" />
                    </Popper>
                </div>
                <div class="col-6 col-sm-4">
                    <Field v-if="brand" name="brand" type="hidden" :value="brand" />
                    <button class="btn btn-primary" type="submit">
                        <span class="mb-0">Search by size</span>
                    </button>
                </div>
            </div>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
    import mostPopularSizes from '@shared/mixins/mostPopularSizes';

    export default {
        props: [
            'options',
            'postcode',
            'tyrePosition',
            'selectedSizeOption',
            'brand'
        ],
        mixins: [mostPopularSizes],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const sizeValidationSchema = yup.object({
                'width': yup.string().required('Width is required'),
                'profile': yup.string().required('Profile is required'),
                'rim': yup.string().required('Rim is required'),
                'size_postcode': yup.string().required('Postcode is required').nullable()
            });

            return {
                sizeValidationSchema,
                selectedWidth: this.selectedSizeOption?.width ?? '',
                selectedProfile: this.selectedSizeOption?.profile ?? '',
                selectedRim: this.selectedSizeOption?.rim ?? '',
            }
        },
        watch: {
            selectedSizeOption: {
                handler(value) {
                    if (!value) {
                        return;
                    }

                    if (value.width != null) {
                        this.selectedWidth = value.width;
                    }

                    if (value.profile != null) {
                        this.selectedProfile = value.profile;
                    }

                    if (value.rim != null) {
                        this.selectedRim = value.rim;
                    }
                },
                deep: true,
            },
        },
        methods: {
            async onSizeSubmit(values) {
                this.emitter.emit('isLoading', true);
                // take object values and format as array, to use join method on.
                var selected_size = Object.values(values);

                //remove any undefined/null entries from posted values
                const normalizedSizes = selected_size.filter(item => item);

                //formats data with pipes for submission
                var format_size = normalizedSizes.join('|');
                
                await axios.post('/ajax/validate_size/' + format_size)
                .then(response => {
                    if(response.data.size_exists == false) {
                        console.log('Size doesn\'t exist, please try again.');
                    }

                    this.$refs.form.submit();

                    return true;
                })
                .catch(error => {
                    this.emitter.emit('isLoading', false);
                    console.error("There was an error!", error);
                });
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            },
        },
        computed: {
            selectedSizeParts() {
                return {
                    width: this.selectedWidth,
                    profile: this.selectedProfile,
                    rim: this.selectedRim,
                };
            },
            formattedOptions: function() {
                return [
                    { label: 'Width', name: 'width', data: this.options.width },
                    { label: 'Profile', name: 'profile', data: this.options.profile },
                    { label: 'Rim', name: 'rim', data: this.options.rim },
                    { label: 'Speed', name: 'speed', data: this.options.speed },
                    // { label: 'Load', name: 'load', data: this.options.load_index },
                ].map((option) => {
                    const groups = this.buildSizeGroups(option, this.selectedSizeParts);

                    if (!groups) {
                        return option;
                    }

                    return {
                        ...option,
                        data: [...groups.popular, ...groups.rest],
                        groups,
                    };
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .size-form {
        .size-input {
            background-color: #fff;
            height: 100%;
            width: 100%;
            margin-bottom: 10px;
            text-transform: capitalize;
            font-weight: 400;
            font-size: 1rem;
            border-radius: 18px;
            max-height: 40px;
        }
        .size-postcode {
            border-radius: 18px;
        }
        .btn {
            @media screen and (min-width: 576px) and (max-width: 767px) {
                font-size: 18px;
            }
            @media screen and (min-width: 992px) and (max-width: 1199px) {
                font-size: 15px;
            }
            width: 100%;
            height: 40px;
        }
    }
    .size-postcode {
        padding: 4.5px 10px;
        font-size: 1rem;
        height: 40px;
    }
</style>
